import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {arrayAlphabeticalSort} from "utils/helpers";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {toTurkishProperCase} from "utils/toTurkishProperCase";

const DynamicNeighborhoodFilter = ({
    value,
    districtId,
    onChange,
    showLabel = true,
    valueKey = "_id",
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    placeholder = "",
    ...props
}) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [neighborhoodLoading, neighborhoodData] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.optionStore.getNeighborhoodList.bind(null, {
            limit: 1000,
            sort: "name",
            districtId
        }),
        dependencies: [districtId],
        initialCall: false,
        waitForResponse: true,
        condition: districtId
    });

    return (
        <React.Fragment>
            {showLabel && <h5>{t("fields.neighborhood", {ns: "common"})}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="neighborhood"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                placeholder={placeholder}
                loading={neighborhoodLoading}
                filterOption={(input, option) => {
                    return (
                        option?.["data-neighborhoodname"]
                            ?.toLocaleLowerCase("TR-tr")
                            ?.indexOf(input.toLocaleLowerCase("TR-tr")) >= 0
                    );
                }}
                {...props}
            >
                {arrayAlphabeticalSort([...(neighborhoodData?.data || [])]).map(
                    (neighborhood, i) => (
                        <SelectField.Option
                            data-testid="neighborhood_option"
                            key={i}
                            data-neighborhoodname={neighborhood.name}
                            value={neighborhood?.[valueKey]}
                        >
                            {toTurkishProperCase(neighborhood.name)}
                        </SelectField.Option>
                    )
                )}
            </SelectField>
        </React.Fragment>
    );
};

export default DynamicNeighborhoodFilter;
